import { apiPaths } from "../utils/apiUtils";
import api from "../api/api";

export async function decisionApi(applicationId, body) {
  try {
    const response = await api.post(`${apiPaths.application}/${applicationId}/decision`, body, {});
    console.log("Decision Response: ", response)

    if (!response) {
      throw new Error("No response received from server.");
    }

    // Handle empty response properly
    return response.data !== undefined && response;
  } catch (error) {
    throw handleApiError(error, "Submit Decision");
  }
}

export async function submitReviewNote(applicationId, action, body) {
  try {
    const response = await api.post(`${apiPaths.application}/${applicationId}/note/${action}`, body, {});
    if (!response) {
      console.error("submitReviewNote response is empty")
      throw new Error("Invalid response structure");
    }
    return response.data;
  } catch (error) {
    console.error("SumbitReviewNote failed", error)
    if (error.response.status === 403) {
      return error.response?.data;
    }
    throw handleApiError(error, "Submit Review Note");
  }
}

export async function removeLock(applicationId, body) {
  try {
    const response = await api.put(`${apiPaths.application}/${applicationId}/removelock`, body, {});
    if (!response) {
      throw new Error("Invalid response structure");
    }
    return response;
  } catch (error) {
    handleApiError(error, "Remove Lock");
    return null;
  }
}

export async function checkDuplicates(applicationId) {
  try {
    const response = await api.get(`${apiPaths.application}/${applicationId}/duplicates`, {});
    if (!response) {
      throw new Error("Invalid response structure");
    }
    return response.data;
  } catch (error) {
    if (error.response.status === 403) {
      return error.response?.data;
    }
    handleApiError(error, "Get Duplicates");
  }
}

/**
 * Centralized error handler for API calls.
 * @param {Error} error - The caught error.
 * @param {string} context - Context message for debugging.
 */
function handleApiError(error, context) {

  const status = error.response?.status;
  const message = error.response?.data?.message || error.message;

  console.error(`[API Error]: ${context} - Status: ${status || "N/A"}, Message: ${message}`);
  return error.response?.data || error.message;
}